import { createContext } from 'react';
import type { MarquePublique } from './marque';

/**
 * Aperçu de la marque sur toute la plateforme (TF-436) : la direction voit le
 * brouillon sur chaque écran, elle seule, avant de l'appliquer. Rien n'est
 * écrit ; un rechargement de la page y met fin.
 */
export interface ApercuMarque {
  marque: MarquePublique;
  /** La saisie de l'onglet « Marque blanche », reprise au retour. */
  brouillon: unknown;
}

export interface ContexteMarque {
  /** La marque affichée : l'aperçu en cours, à défaut celle en vigueur. */
  marque: MarquePublique;
  apercu: ApercuMarque | null;
  demarrerApercu: (apercu: ApercuMarque) => void;
  arreterApercu: () => void;
}

export const ContexteMarqueReact = createContext<ContexteMarque | null>(null);
